/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAsinh } from '../../factoriesAny.js';
export var asinhDependencies = {
  typedDependencies,
  createAsinh
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesAsinh.generated.js
// module id = null
// module chunks = 